import React, {useEffect, useState, useContext} from "react";
import "./StatusBar.scss";
import CompletedIcon from "../../assets/icons/CompletedIcon";
import InprogressIcon from "../../assets/icons/InprogressIcon";
import DelayedIcon from "../../assets/icons/DelayedIcon";
import UnassignedIcon from "../../assets/icons/UnassignedIcon";
import PopInNavIcon from "../../assets/icons/PopInNavIcon";
import dashBoardApi from "../../services/dashboardApi";
import { AuthContext } from "../../context/AuthContext";

const StatusBar = ({openPopin, showRoList,reload }) => {
  const { dateChange } = useContext(AuthContext);
  const [roStatusCount, setROStatusCount] = useState(null);

  useEffect(() => {    
    fetchROStatusData(); 
  },[reload, dateChange]);

const fetchROStatusData = async () => {
try {
  const dateValue = dateChange.toISOString();
  const response = await dashBoardApi.getRepairOrderStatusCount(dateValue);
  let statusCount=response?.data?.roStatusCount?.rosGroupCount;
  setROStatusCount(statusCount)
} catch(error){

} finally {

}

}


  return (
    <div className="header">
        <div className="status-count">
        <div className="status unassigned">
            <div className="status-icon">
              <UnassignedIcon />
            </div>
            <div className="status-detail">
              <div className="text">
                <div className="count">{roStatusCount?.unAssignedCount ? roStatusCount?.unAssignedCount : 0}</div>
                <div className="label-name">Unassigned</div>
              </div>
              <div className="progress-bar">
                <div className="progress" style={{ width: roStatusCount?.unAssignedPercentage ? roStatusCount?.unAssignedPercentage : 0}}>
                  {" "}
                </div>
              </div>
            </div>
          </div>
          <div className="status in-progress">
            <div className="status-icon">
              <InprogressIcon />
            </div>
            <div className="status-detail">
              <div className="text">
                <div className="count">{roStatusCount?.inProgressCount ? roStatusCount?.inProgressCount : 0}</div>
                <div className="label-name">In Progress</div>
              </div>
              <div className="progress-bar">
                <div className="progress" style={{ width: roStatusCount?.inProgressPercentage ? roStatusCount?.inProgressPercentage : 0}}>
                  {" "}
                </div>
              </div>
            </div>
          </div>
          <div className="status delayed">
            <div className="status-icon">
              <DelayedIcon />
            </div>
            <div className="status-detail">
              <div className="text">
                <div className="count">{roStatusCount?.delayedCount ? roStatusCount?.delayedCount : 0}</div>
                <div className="label-name">Delayed</div>
              </div>
              <div className="progress-bar">
                <div className="progress" style={{ width: roStatusCount?.delayedPercentage ? roStatusCount?.delayedPercentage : 0}}>
                  {" "}
                </div>
              </div>
            </div>
          </div>
          <div className="status completed">
            <div className="status-icon">
              <CompletedIcon />
            </div>
            <div className="status-detail">
              <div className="text">
                <div className="count">{roStatusCount?.completedCount? roStatusCount?.completedCount : 0}</div>
                <div className="label-name">Completed</div>
              </div>
              <div className="progress-bar">
                <div className="progress" style={{ width: roStatusCount?.completedPercentage ? roStatusCount?.completedPercentage : 0}}>
                  {" "}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="status-color">
          <div className="color-block">
            <div className="color not-started">
              <span></span>
              <label>Not started</label>
            </div>
            <div className="color in-progress">
              <span></span>
              <label>In progress</label>
            </div>
          </div>
          <div className="color-block">
            <div className="color completed">
              <span></span>
              <label>Completed</label>
            </div>
            <div className="color delayed">
              <span></span>
              <label>Delayed</label>
            </div>
          </div>
          <div className="color-block">
            <div className="color minutes">
              <span></span>
              <label>Final Minutes</label>
            </div>
          </div>
        </div>
        <div className="parts-details">
          <div className="parts available">
            <span></span>
            <label>Parts Available</label>
          </div>
          <div className="parts not-available">
            <span></span>
            <label>Parts not Available</label>
          </div>
        </div>        
        {showRoList && (
        <button className="right-nav" onClick={openPopin}>
          <PopInNavIcon />
        </button>
        )}
      </div>
  );
};

export default StatusBar;
